import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { useForm } from '@/common/form/FormContext';
import { Grid } from '@/common/grid/Grid';
import { useEffect, useMemo, useRef, useState } from 'react';

const FIELD_DEFS = [
  { field: 'code', displayName: 'Code', module: 'sc', entity: 'INCTV_RBT', type: 'HYPERLINK' },
  { field: 'dueDate', displayName: 'Due Date', type: 'DATE' },
  { field: 'dueAmt', displayName: 'Due Amount', type: 'MONEY' },
];

// Client-side grid that loads its rows once the grid is ready and whenever they change
const UnpaidGrid = ({ rows }) => {
  const gridRef = useRef();
  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {
    if (isGridReady && gridRef.current && rows) {
      gridRef.current.setDataSource(rows);
    }
  }, [isGridReady, rows]);

  return (
    <Grid
      ref={gridRef}
      gridOptions={{ fieldDefs: FIELD_DEFS, rowModelType: 'clientSide' }}
      events={{ onGridReady: () => setIsGridReady(true) }}
    />
  );
};

/**
 * Every unpaid Incentive Rebate ending in the selected period range. The plugin decides which statuses count as
 * unpaid and returns the rows already ordered, so no sort is applied here.
 */
export const InctvRbtUnpaidCard = () => {
  const { formValues } = useForm();
  const { startPeriodId, endPeriodId, custExpr, ctrtExpr } = formValues;
  const reqParam = useMemo(
    () => ({ startPeriodId, endPeriodId, custExpr, ctrtExpr }),
    [startPeriodId, endPeriodId, custExpr, ctrtExpr],
  );

  return (
    <DashboardCard
      title="Unpaid Rebates"
      description="Every Incentive Rebate ending in the selected periods that still owes money, soonest due first and largest amount first within a due date"
      plugin="INCTV_RBT_UNPAID_DATA_PLUGIN"
      module="sc"
      reqParam={reqParam}
    >
      {(rows) => <UnpaidGrid rows={rows} />}
    </DashboardCard>
  );
};
